import { axiosInstance } from "../../../axios/axiosInstance";
import { userRoles } from "../../../constants";

const API_SERVICE_PROVIDER_USER_CHAT_URL = "organization/chat-conversation";
const API_SERVICE_PROVIDER_USER_CHAT_POST_URL = "organization/chat-post";
const API_SERVICE_PROVIDER_USER_CHAT_MODULE_LIST_URL =
  API_SERVICE_PROVIDER_USER_CHAT_URL + "/list";
const API_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID_URL =
  API_SERVICE_PROVIDER_USER_CHAT_URL + "/view";
const API_SEND_SERVICE_PROVIDER_USER_CHAT_MESSSAGE_URL =
  API_SERVICE_PROVIDER_USER_CHAT_URL + "/chat_message";
const API_SEND_SERVICE_PROVIDER_USER_CHAT_REQUEST_URL =
  API_SERVICE_PROVIDER_USER_CHAT_POST_URL + "/request-list";
const API_SEND_SERVICE_PROVIDER_USER_CHAT_REQUEST_VIEW_URL =
  API_SERVICE_PROVIDER_USER_CHAT_POST_URL + "/request-view";
const API_SERVICE_PROVIDER_UPDATE_REQUEST_STATUS_URL = API_SERVICE_PROVIDER_USER_CHAT_POST_URL + "/update-request-status";

export const getServiceProviderUserChat = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SERVICE_PROVIDER_USER_CHAT_MODULE_LIST_URL}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`
  );
};

export const getServiceProviderUserChatRequest = (dataToBeSent) => {
  return axiosInstance.get(
    `${API_SEND_SERVICE_PROVIDER_USER_CHAT_REQUEST_URL}/${
      dataToBeSent?.userId
    }/${userRoles.SERVICE_PROVIDER_ADMIN}?page=${
      dataToBeSent?.page || ""
    }&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`
  );
};

export const getServiceProviderUserChatDetailsById = (dataToBeSent) => {
  return axiosInstance.get(
    API_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID_URL +
      "/" +
      dataToBeSent?.selectedServiceProviderUserChatId
  );
};

export const getServiceProviderRequestChatDetailsById = (dataToBeSent) => {
  return axiosInstance.get(
    API_SEND_SERVICE_PROVIDER_USER_CHAT_REQUEST_VIEW_URL +
      "/" +
      dataToBeSent?.id
  );
};

export const sendUserChatMessage = (dataToBeSent) => {
  return axiosInstance.postForm(
    API_SEND_SERVICE_PROVIDER_USER_CHAT_MESSSAGE_URL +
      "/" +
      dataToBeSent?.conversation_id,
    dataToBeSent
  );
};

export const updateRequestStatus = ({selectedRequestId, ...rest}) => {
  return axiosInstance.post(API_SERVICE_PROVIDER_UPDATE_REQUEST_STATUS_URL + "/" + selectedRequestId, rest);
};
